exports = module.exports = require("../../../../../../../usr/lib/node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".besidaMob-social__root--1Oijm{list-style:none;margin:0;padding:0}.besidaMob-social__item--zP5h8+.besidaMob-social__item--zP5h8{margin:10px 0 0}.besidaMob-social__link--3rsuP{-ms-flex-align:center;-ms-flex-pack:center;-webkit-box-align:center;-webkit-box-pack:center;align-items:center;background:#fff;border-radius:2px;color:#333;cursor:pointer;display:-webkit-box;display:-ms-flexbox;display:flex;font-size:13px;font-weight:700;height:40px;justify-content:center}.besidaMob-social__link--3rsuP:hover{color:#333;text-decoration:none}.besidaMob-social__icon--3kjF7{display:inline-block;height:20px;margin:0 10px 0 0;vertical-align:middle;width:20px}", ""]);

// exports
exports.locals = {
	"root": "besidaMob-social__root--1Oijm",
	"item": "besidaMob-social__item--zP5h8",
	"link": "besidaMob-social__link--3rsuP",
	"icon": "besidaMob-social__icon--3kjF7"
};